export default __webpack_public_path__ + "static/media/IconGoogleSheet.e39384a5.png";